module.exports = __webpack_public_path__ + "img/banner_1.5128fbae.jpg";